var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ruby_logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.089,
    height: 32,
    viewBox: "0 0 32.089 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.848,
    y1: 1.114,
    x2: 0.583,
    y2: 0.646,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e42b1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.167,
    y1: 0.609,
    x2: 0.017,
    y2: 0.193,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.758,
    y1: 2.193,
    x2: 0.39,
    y2: 0.078,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.072,
    x2: 0.665,
    y2: 0.791,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#de3b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.462,
    y1: 0.163,
    x2: 0.499,
    y2: 0.83,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#e4714e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#be1a0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.37,
    y1: 0.156,
    x2: 0.495,
    y2: 0.925,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.136,
    y1: 0.583,
    x2: 0.858,
    y2: -0.467,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c81f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bf0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.276,
    y1: 0.211,
    x2: 0.507,
    y2: 0.791,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#de4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bf190b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf190b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.207,
    y1: 1.223,
    x2: 1.042,
    y2: -0.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c82f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#820c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#b31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.588,
    y1: 0.652,
    x2: 0.12,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c0c01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#990c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a80d0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80d0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.793,
    y1: 0.628,
    x2: 0.231,
    y2: 0.179,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e110b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9e0c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e0c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.929,
    y1: 0.741,
    x2: 0.598,
    y2: 0.397,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79130d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9e120b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e120b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.32,
    cy: 0.402,
    r: 1.331,
    gradientTransform: "translate(0.239) scale(0.523 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a80d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7e0e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e0e08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.135,
    cy: 0.409,
    r: 1.135,
    gradientTransform: "translate(0.111) scale(0.778 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a30c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#800e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800e08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.566,
    y1: 1.017,
    x2: 0.031,
    y2: 0.12,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9e100a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b3100c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3100c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.309,
    y1: 0.356,
    x2: 0.925,
    y2: 1.007,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#910f08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#791c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791c12"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "polygon3282",
    d: "M58.7,54.6,40.38,65.48,64.1,63.87l1.827-23.92Z",
    transform: "translate(-33.84 -33.48)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3293",
    d: "M147.8,114.723l-2.039-14.073-5.554,7.334Z",
    transform: "translate(-117.501 -84.349)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3304",
    d: "M64.579,181.473,49.642,180.3l-8.772,2.768Z",
    transform: "translate(-34.251 -151.099)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3319",
    d: "M17.82,134.155l3.732-12.225-8.211,1.756Z",
    transform: "translate(-11.179 -102.182)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3334",
    d: "M71.59,76.589,68.156,63.14,58.33,72.351Z",
    transform: "translate(-48.883 -52.914)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3349",
    d: "M131.875,25.056l-9.288-7.586L120,25.832Z",
    transform: "translate(-100.565 -14.641)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3362",
    d: "M120.4.56l-5.463,3.019L111.49.52Z",
    transform: "translate(-93.433 -0.436)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "polygon3375",
    d: "M0,110.766l2.288-4.174L.437,101.62Z",
    transform: "translate(0 -85.162)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path3377",
    d: "M1.94,16.3,3.8,21.584,11.9,19.769l9.24-8.587L23.743,2.9,19.637,0l-6.98,2.612c-2.2,2.046-6.467,6.093-6.621,6.169S3.218,13.9,1.94,16.3Z",
    transform: "translate(-1.626)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path3400",
    d: "M12.6,10.981c4.766-4.726,10.911-7.518,13.269-5.139S25.725,14,20.958,18.728,10.123,26.4,7.767,24.019s.065-8.313,4.831-13.038Z",
    transform: "translate(-5.744 -4.171)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path3413",
    d: "M41,133.924l3.7-12.264L57,125.61C52.553,129.779,47.608,133.3,41,133.924Z",
    transform: "translate(-34.36 -101.956)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path3424",
    d: "M120.56,64.792l3.157,12.5c3.714-3.9,7.047-8.1,8.679-13.3Z",
    transform: "translate(-101.034 -53.635)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path3435",
    d: "M145.369,11.107c1.263-3.813,1.555-9.282-4.4-10.3l-4.888,2.7Z",
    transform: "translate(-114.04 -0.679)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path3437",
    d: "M0,137.1c.175,6.292,4.715,6.386,6.648,6.441L2.182,133.11Z",
    transform: "translate(0 -111.552)",
    fill: "#9e1209",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path3448",
    d: "M120.669,64.962c2.854,1.754,8.605,5.277,8.722,5.341.181.1,2.48-3.876,3-6.124Z",
    transform: "translate(-101.125 -53.785)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path3459",
    d: "M63.83,121.66l4.949,9.549a32,32,0,0,0,7.317-5.592Z",
    transform: "translate(-53.492 -101.956)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path3472",
    d: "M9.721,133.179l-.7,8.351c1.323,1.807,3.144,1.965,5.053,1.824C12.692,139.915,9.932,133.04,9.721,133.179Z",
    transform: "translate(-7.559 -111.608)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-13)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path3485",
    d: "M135.9,3.5l9.833,1.38c-.525-2.224-2.136-3.659-4.883-4.107Z",
    transform: "translate(-113.89 -0.645)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-14)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyIcon);
export default __webpack_public_path__ + "static/media/rubyIcon.95cb872c0c1b3a5b5a8ea2cf9309b596.svg";
export { ForwardRef as ReactComponent };